import { ComponentRef, Injectable, Optional } from "@angular/core";
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of, tap, delay, takeUntil } from 'rxjs'

import { GlobalSpinnerComponent } from "./global-spinner.component";
import { GlobalSpinnerActions } from "./actions-types";
import { GlobalSpinnerSettings } from "./global-spinner.actions";

@Injectable()
export class GlobalSpinnerEffects {

    spinnerOn$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(
                    GlobalSpinnerActions.showGlobalSpinner
                ),
                tap((action) => {
                    this.spinnerQueueIndex++
                    if (this.spinnerQueueIndex == 1) {
                        of(void 0).pipe(
                            delay(action.settings?.timeoutOffset ?? 0),
                            takeUntil(this.actions$.pipe(ofType(GlobalSpinnerActions.hideGlobalSpinner)))
                        ).subscribe(() => {
                            this.spinnerInstance = this.spinnerTopRef.attach(new ComponentPortal(GlobalSpinnerComponent))
                            this.setSpinnerOption(this.spinnerInstance, action.settings)
                        })
                    }
                    else {
                        this.setSpinnerOption(this.spinnerInstance, action.settings)
                    }
                })
            ),
        { dispatch: false }
    )

    spinnerOff$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(
                    GlobalSpinnerActions.hideGlobalSpinner
                ),
                tap(() => {
                    this.spinnerQueueIndex--
                    if (this.spinnerQueueIndex == 0) this.spinnerTopRef.detach()
                })
            ),
        { dispatch: false }
    )

    private readonly spinnerTopRef
    private spinnerInstance!: ComponentRef<GlobalSpinnerComponent>
    private spinnerQueueIndex: number = 0

    constructor(private actions$: Actions, private overlay: Overlay) {
        this.spinnerTopRef = this.overlay.create({
            backdropClass: 'blue-theme',
            hasBackdrop: true,
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
        });
    }

    private setSpinnerOption(ref: ComponentRef<GlobalSpinnerComponent>, settings: Partial<GlobalSpinnerSettings> | undefined) {
        if (settings) {
            settings.color && (this.spinnerInstance.instance.color = settings.color)
            settings.mode && (this.spinnerInstance.instance.mode = settings.mode)
            settings.value && (this.spinnerInstance.instance.value = settings.value)
        }
    }
}